import { Component, HostListener, inject, signal } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

import { Sidebar } from '@core/components/sidebar/sidebar';
import { Topbar } from '@core/components/topbar/topbar';
import { AuthService } from '@core/services/auth';

const MOBILE_BREAKPOINT = 768;

@Component({
  selector: 'app-root',
  imports: [RouterLink, RouterOutlet, ToastModule, ConfirmDialogModule, Topbar, Sidebar],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly authAPIs = inject(AuthService);

  isAuthenticated = this.authAPIs.isAuthenticated;
  readonly title = signal('Youtopia Admin');
  readonly currentYear = new Date().getFullYear();
  readonly sidebarOpen = signal(window.innerWidth > MOBILE_BREAKPOINT);

  toggleSidebar(): void {
    this.sidebarOpen.update((v) => !v);
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      this.sidebarOpen.set(false);
    }
  }
}
